import { render, staticRenderFns } from "./caseAdd.vue?vue&type=template&id=2fa539df&scoped=true&"
import script from "./caseAdd.vue?vue&type=script&lang=js&"
export * from "./caseAdd.vue?vue&type=script&lang=js&"
import style0 from "./caseAdd.vue?vue&type=style&index=0&id=2fa539df&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa539df",
  null
  
)

export default component.exports